import {
    FETCH_SCHEDULE_SUCCESS,
    FETCH_SCHEDULE_REQUEST_ERRORS,
    FETCH_MAP_VIEW_SUCCESS,
    FETCH_SCHEDULE_REQUEST_LOADING,
    CLEAR_SCHEDULE_SUCCESS,

} from "api/menu/schedule/actions";

const initialState = {
    loading: false,
    errors: [],

    scheduleList: [],
    scheduleListOptions: {},

    mapList: [],
    mapListOptions: {},
};

export default function(state = initialState, action) {
    switch (action.type) {
        case FETCH_SCHEDULE_REQUEST_LOADING:
            return {
                ...state,
                loading: true
            };
        case FETCH_SCHEDULE_REQUEST_ERRORS:
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        case FETCH_SCHEDULE_SUCCESS:
            if (Array.isArray(action.payload)) {
                return {
                    ...state,
                    loading: false,
                    scheduleList: action.payload
                };
            }
            return {
                ...state,
                loading: false,
                scheduleList: action.payload.payload,
                scheduleListOptions: {
                    metadata: action.payload.metadata || state.scheduleListOptions.metadata,
                    pageNumber: action.payload.pageNumber,
                    pageSize: action.payload.pageSize,
                    totalFilteredRecords: action.payload.totalFilteredRecords,
                    totalRecords: action.payload.totalRecords,
                },
            };
        case FETCH_MAP_VIEW_SUCCESS:
            return {
                ...state,
                loading: false,
                mapList: action.payload.payload,
                mapListOptions: {
                    metadata: action.payload.metadata || state.mapListOptions.metadata,
                    pageNumber: action.payload.payload.pageNumber,
                    pageSize: action.payload.payload.pageSize,
                    totalFilteredRecords: action.payload.payload.totalFilteredRecords,
                    totalRecords: action.payload.payload.totalRecords,
                },
            };
        case CLEAR_SCHEDULE_SUCCESS:
            return {
                loading: false,
                errors: [],
                scheduleList: [],
                scheduleListOptions: {},
                mapList: [],
                mapListOptions: {}
            };
        default:
            return state;
    }
}
